export default "__VITE_ASSET__843822c2__"